interface AutoSaveTimerOptions {
  onSave: () => void | Promise<void>;
  interval?: number;
}

export const createAutoSaveTimer = (options: AutoSaveTimerOptions) => {
  let timerId: ReturnType<typeof setInterval> | null = null;

  const startTimer = () => {
    if (timerId) return; // Already running

    timerId = setInterval(async () => {
      await options.onSave();
    }, options.interval || 10000);
  };

  const stopTimer = () => {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  };

  const isRunning = () => timerId !== null;

  return { startTimer, stopTimer, isRunning };
};
